let conversionTableFromM2 = {
    acre: {
        value: 4046.856,
        sign: "/",
        si: "Acres"
    },
    squarekilometer: {
        value: 1000000,
        sign: "/",
        si: "Square Kilometres"
    },
    squaremetre: {
        value: 1,
        sign: "*",
        si: "Square Metres"
    },
    squaremile: {
        value: 2590000,
        sign: "/",
        si: "Square Miles"
    },
    squareyard: {
        value: 1.196,
        sign: "*",
        si: "Square Yards"
    },
    squarefoot: {
        value: 10.764,
        sign: "*",
        si: "Square Feet"
    },
    squareinch: {
        value: 1550.003,
        sign: "*",
        si: "Square Inches"
    },
    hectare: {
        value: 10000,
        sign: "/",
        si: "Hectares"
    }
};

let returnVal = {
    areaInM2: 0.0,
    unitConvertedTo: "",
    areaInConvertedUnit: ""
};

export function ConvertFromM2To(unit, areaInM2In) {
    try {
        if (!unit) {
            return returnVal;
        }
        if (!areaInM2In || areaInM2In < 1) {
            return returnVal;
        }

        var areaConverted = 0.0;

        if (conversionTableFromM2[unit].sign == "*") {
            // eslint-disable-next-line
            areaConverted = areaInM2In * conversionTableFromM2[unit].value;
            areaConverted = areaConverted.toFixed(2);
            // eslint-disable-next-line
            areaConverted = areaConverted;
        }
        if (conversionTableFromM2[unit].sign == "/") {
            // eslint-disable-next-line
            areaConverted = areaInM2In / conversionTableFromM2[unit].value;
            areaConverted = areaConverted.toFixed(2);
            // eslint-disable-next-line
            areaConverted = areaConverted;
        }
        return {
            areaInM2: areaInM2In,
            unitConvertedTo: unit,
            unitConvertedToSI: conversionTableFromM2[unit].si,
            areaInConvertedUnit: areaConverted
        };
    } catch (e) {
        return 0;
    }
}

export const areaConvFunctions = {
    ConvertFromM2To
};
